import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './ShareCollectionModal.styled';
import { Modal } from '@/components/UI/Modal/Modal';
import { CloseIcon, ShareLinkIcon } from '@/components/UI/Icons/Icons';

interface ShareCollectionModalProps {
  link: string;
  isOpen: boolean;
  onClose: () => void;
}

export const ShareCollectionModal = ({
  link,
  isOpen,
  onClose,
}: ShareCollectionModalProps) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  const handleShare = () => {
    setIsCopied(true);
    navigator.clipboard.writeText(link);

    setTimeout(() => {
      setIsCopied(false);
    }, 1000);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth={600}>
      <S.Content>
        <S.Header>
          <S.Title>{t('bookmark_collections.share_modal_title')}</S.Title>
          <S.CloseButton onClick={onClose}>
            <CloseIcon />
          </S.CloseButton>
        </S.Header>
        <S.Description>
          {t('bookmark_collections.share_modal_description')}
        </S.Description>
        <S.ShareInput>
          <ShareLinkIcon />
          <S.ShareInputText>{link}</S.ShareInputText>
          <S.ShareButton onClick={handleShare}>
            {isCopied
              ? t('common.copied')
              : t('bookmark_collections.share_modal_button')}
          </S.ShareButton>
        </S.ShareInput>
      </S.Content>
    </Modal>
  );
};
